import Button from './button';
import { ButtonProps } from './button-types';
import './button.styles.scss';

interface Props extends ButtonProps {
    count: number;
}

export default function ButtonCount({ count, children, ...props }: Props) {
    return (
        <Button {...props}>
            {children}
            <span className="button-count-container">
                <span className="button-count">{count}</span>
            </span>
        </Button>
    );
}
